// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
    min-height: 400px;
    display: flex;
    flex-direction: column;
}

.table-title {
    margin-bottom: 12px;
    margin-left: 12px;
}

.soc-cell {
    display: flex;
    align-items: center;
    justify-content: end;
    flex-direction: column;
}

.soc-cell-timeline {
    display: flex;
    align-items: center;
    justify-content: end;
}

.soc-value {
    margin-right: 5px;
}

.fixed-column-height {
    height: 608px;
}

.card-height {
    height: 210px;
}

.metric-text {
    font-size: 15px;
}

.usage-history-chart {
    width: 100%;
}

.history-segement {
    width: 100%;
    display: flex;
    margin-right: 2px;
}

/* Project dropdown - dynamic width for long names */
[data-test="Cat-projects-Dropdown"] {
    min-width: 190px;
    max-width: 400px;
    width: auto;
}

[data-test="Cat-projects-Dropdown"]::part(trigger) {
    white-space: nowrap;
    width: auto;
}

[data-test="Cat-projects-Dropdown"]::part(label) {
    white-space: nowrap;
    display: block;
}

/* Prevent text selection on panel headers */
[data-test="map-title"],
[data-test="network-diagram-title"],
cat-heading {
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}

/*
 * Refreshed Live Dashboard chrome (eflowLiveDashboardRefresh flag).
 * These .live-dashboard-* classes are applied by ProjectDetails only on the Live tab, so
 * the legacy layout is untouched when the flag is off. Blocks components are shadow-DOM
 * web components, so their internals are reachable only through ::part().
 * The tag+class selector also outranks the [data-test="Cat-projects-Dropdown"] rules
 * above, so these overrides win without needing !important.
 */
cat-dropdown.live-dashboard-project-dropdown {
    min-width: 0;
    max-width: 100%;
    width: auto;

    --cat-panel-box-shadow: 0 2px var(--box-shadow-med, 12px) 0 var(--shadows-default, rgba(31, 31, 31, 0.24));

    /* Figma 26-44764 option rows are a fixed 40px tall with 4/8/8/8 padding and a 4px
       radius; --cat-list-item-link-* are custom properties, so they cross the cat-list /
       cat-list-item shadow boundaries from this single ancestor rule. */
    --cat-list-item-link-min-height: 2.5rem;
    --cat-list-item-link-padding-block-start: 0.25rem;
    --cat-list-item-link-padding-block-end: 0.5rem;
    --cat-list-item-link-padding-inline-start: 0.5rem;
    --cat-list-item-link-padding-inline-end: 0.5rem;
    --cat-list-item-link-border-radius: 0.25rem;
}

/*
 * Figma 26-44764 "options menu" is a fixed 313px wide regardless of the trigger's (name-sized)
 * width. isDynamicWidth can't be used for this: it also forces the trigger's own input-wrap to
 * that same width, stretching the pill itself. Targeting the panel part directly instead leaves
 * the trigger's width untouched.
 */
cat-dropdown.live-dashboard-project-dropdown::part(panel-component) {
    width: 19.5625rem;
    margin-top: 0.1875rem;
}

/*
 * Figma 26-44764 keeps the trigger's plain border with no blue "active"/focus outline,
 * even while the panel is open. The component's own shadow-DOM rules
 * (.cat-is-active .cat-c-dropdown__body, .cat-c-dropdown__select:focus .cat-c-dropdown__body)
 * are two classes deep, which outranks this single-class ::part() selector, so !important
 * is required to win the cascade across the shadow boundary.
 */
cat-dropdown.live-dashboard-project-dropdown::part(body) {
    border-width: 0 !important;
    background-color: transparent !important;
    padding: 0;
    outline: none !important;
}

/* Figma 26-44764 has no focus/active outline from a mouse click, but keyboard focus still
   needs a visible indicator — :not(:focus-visible) leaves that untouched. */
cat-dropdown.live-dashboard-project-dropdown::part(body):focus-visible {
    outline: 2px solid var(--cat-theme-color-focus-ring) !important;
    outline-offset: 2px;
}

cat-dropdown.live-dashboard-project-dropdown::part(body):focus:not(:focus-visible) {
    outline: none;
}

/*
 * The dropdown-panel's own body is what CatDropdown caps to a short fixed max-height
 * and makes scrollable (hasScroll is always true internally, via .cat-has-scroll, which
 * is two classes deep and outranks this single-class ::part() selector without !important).
 * That cap is what abruptly clipped the list before reaching the "Add New Project" footer,
 * and its default native scrollbar is what showed up/down arrow buttons. Handing scroll
 * ownership to .live-dashboard-project-list-scroll (see ProjectDetails.tsx) instead lets
 * this element grow to fit exactly: up to 6 rows plus the always-visible footer.
 */
cat-dropdown.live-dashboard-project-dropdown::part(dropdown-panel__body) {
    max-height: none !important;
    overflow: visible !important;
}

/*
 * Refreshed project dropdown scrollbar. The project list owns scrolling;
 * browser-native up/down arrow buttons are hidden.
 */
.live-dashboard-project-list-scroll::-webkit-scrollbar {
    width: 6px;
}

.live-dashboard-project-list-scroll::-webkit-scrollbar-button,
.live-dashboard-project-list-scroll::-webkit-scrollbar-button:single-button,
.live-dashboard-project-list-scroll::-webkit-scrollbar-button:vertical:start:decrement,
.live-dashboard-project-list-scroll::-webkit-scrollbar-button:vertical:end:increment {
    display: none;
    width: 0;
    height: 0;
    background: transparent;
    -webkit-appearance: none;
            appearance: none;
}

.live-dashboard-project-list-scroll::-webkit-scrollbar-track {
    background: transparent;
}

.live-dashboard-project-list-scroll::-webkit-scrollbar-thumb {
    min-height: 40px;
    border-radius: 2px;
    background: #ccc;
    box-shadow:
        0 0 2px 0 #fff,
        0 0 2px 0 #fff;
}

.live-dashboard-project-list-scroll::-webkit-scrollbar-thumb:hover {
    background: #777;
}

cat-dropdown.live-dashboard-project-dropdown::part(text) {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 2rem;
    font-family: "Roboto Flex", sans-serif;
}

cat-dropdown.live-dashboard-project-dropdown::part(text-container) {
    padding-right: 0;
    padding-left: 0;
}

cat-dropdown.live-dashboard-project-dropdown:hover .live-dashboard-project-dropdown-transfer-icon-container {
    background: #ccc;
    background: var(--bg-subtle-hover, #ccc);
}

.live-dashboard-project-edit-tooltip {
    --cat-theme-box-shadow-md: 0 6px 16px rgba(0, 0, 0, 0.15);
}

cat-tooltip.live-dashboard-project-edit-tooltip::part(content) {
    backdrop-filter: blur(10px);
}

cat-tooltip.live-dashboard-project-edit-tooltip::part(part-default) {
    padding: 0.125rem 0.5rem;
}

.live-dashboard-project-edit-button-container:hover {
    background: #ccc;
    background: var(--bg-subtle-hover, #ccc);
}

cat-button.live-dashboard-project-edit-button::part(button),
cat-button.live-dashboard-project-edit-button::part(button):hover,
cat-button.live-dashboard-project-edit-button::part(button):active {
    background-color: transparent;
    border-color: transparent;
}

/* Figma 26-41627 puts a 4px gap between the transfer icon and the project name. */
cat-dropdown.live-dashboard-project-dropdown::part(input-wrap) {
    gap: 0.25rem;
}

/*
 * Figma 26-41627 has no chevron: the pill is transfer icon -> project name -> edit.
 * Hiding the button part alone proved unreliable, so the icon part is hidden too.
 */
cat-dropdown.live-dashboard-project-dropdown::part(chevron-down-button),
cat-dropdown.live-dashboard-project-dropdown::part(arrow-icon),
cat-dropdown.live-dashboard-project-dropdown::part(icon-wrapper),
cat-dropdown.live-dashboard-project-dropdown::part(separator) {
    display: none;
}

/* Figma 26-44764 "options menu" list rows: project name is body/default (16px/24px). cat-list-item
   is slotted content (not part of cat-dropdown's own shadow tree), so it's reached directly. */
cat-dropdown.live-dashboard-project-dropdown cat-list-item::part(text) {
    font-family: "Roboto Flex", sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    color: #1f1f1f;
}

/* Figma 26-44764 has no checkmark on the selected row — just the status badge. */
cat-dropdown.live-dashboard-project-dropdown cat-list-item::part(icon-after) {
    display: none;
}

/* Figma 26-44764 rows are all white; grey is a hover-only state, not a persistent
   "current selection" background. The component keys that persistent background off
   the host's own internal aria-selected/current state (list-item.styles.ts), which lives
   entirely inside its shadow DOM and outranks any ::part() override on specificity alone,
   so !important is required here. :not(:hover) leaves the real hover feedback untouched. */
cat-dropdown.live-dashboard-project-dropdown cat-list-item::part(link):not(:hover) {
    background-color: #fff !important;
    background-color: var(--cat-theme-color-background-default, #fff) !important;
}

/* Badge label is CSS-generated (not a text node) so cat-dropdown's textContent-based trigger
   label (see getSelectedItemLabel in dropdown.ts) never picks it up — see ProjectDetails.tsx. */
.project-status-badge::after {
    content: attr(data-label);
}

/*
 * Roboto Flex across the refreshed Asset Portfolio / Network Diagram / Map panels.
 * Blocks components read their font from these design tokens rather than an inherited
 * font-family, and custom properties are the only thing that crosses the shadow
 * boundary, so the tokens are redeclared alongside the plain font-family.
 */
.live-dashboard-panel {
    font-family: "Roboto Flex", sans-serif;

    --cat-theme-typography-body-font-family: "Roboto Flex", sans-serif;
    --cat-theme-typography-body-sm-font-family: "Roboto Flex", sans-serif;
    --cat-theme-typography-label-font-family: "Roboto Flex", sans-serif;
    --cat-theme-typography-label-lg-font-family: "Roboto Flex", sans-serif;
    --cat-theme-typography-label-sm-font-family: "Roboto Flex", sans-serif;
    --cat-theme-typography-title-font-family: "Roboto Flex", sans-serif;
    --cat-theme-typography-title-sm-font-family: "Roboto Flex", sans-serif;
    --cat-theme-typography-footnote-font-family: "Roboto Flex", sans-serif;
    --cat-theme-typography-footnote-bold-font-family: "Roboto Flex", sans-serif;
}

/* Google Maps sets its own font on .gm-style, so inheritance alone never reaches it. */
.live-dashboard-panel .gm-style,
.live-dashboard-panel .gm-style .gm-style-iw {
    font-family: "Roboto Flex", sans-serif;
}

cat-tabs.live-dashboard-tabs::part(header) {
    justify-content: center;
    margin-bottom: 1.5rem;
}

cat-tabs.live-dashboard-tabs::part(list) {
    max-width: 100%;
}

/* Centre the tab strip against the page header once there is room for it (Tailwind xl). */
@media (min-width: 1280px) {
    cat-tabs.live-dashboard-tabs::part(header) {
        position: absolute;
        top: 46px;
        left: 50%;
        max-width: 42%;
        margin-bottom: 0;
        transform: translateX(-50%);
    }
}

cat-tab.live-dashboard-tabs-item::part(button) {
    width: 127px;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
}

cat-tab.live-dashboard-tabs-item::part(wrap) {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Projects/ProjectDetails.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA,oDAAoD;AACpD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;;;IAGI,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;;;;;;EAOE;AACF;IACI,YAAY;IACZ,eAAe;IACf,WAAW;;IAEX,0GAAuG;;IAEvG;;wEAEoE;IACpE,uCAAuC;IACvC,iDAAiD;IACjD,8CAA8C;IAC9C,iDAAiD;IACjD,+CAA+C;IAC/C,2CAA2C;AAC/C;;AAEA;;;;;EAKE;AACF;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;;;;EAME;AACF;IACI,0BAA0B;IAC1B,wCAAwC;IACxC,UAAU;IACV,wBAAwB;AAC5B;;AAEA;4EAC4E;AAC5E;IACI,+DAA+D;IAC/D,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;;;;;EAQE;AACF;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;;;EAGE;AACF;IACI,UAAU;AACd;;AAEA;;;;IAII,aAAa;IACb,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,wBAAgB;YAAhB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB;;sBAEkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAwC;IAAxC,wCAAwC;AAC5C;;AAEA;IACI,yDAAsD;AAC1D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAwC;IAAxC,wCAAwC;AAC5C;;AAEA;;;IAGI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA,kFAAkF;AAClF;IACI,YAAY;AAChB;;AAEA;;;EAGE;AACF;;;;IAII,aAAa;AACjB;;AAEA;+FAC+F;AAC/F;IACI,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,iFAAiF;AACjF;IACI,aAAa;AACjB;;AAEA;;;;2FAI2F;AAC3F;IACI,iCAA4E;IAA5E,4EAA4E;AAChF;;AAEA;gGACgG;AAChG;IACI,yBAAyB;AAC7B;;AAEA;;;;;EAKE;AACF;IACI,sCAAsC;;IAEtC,kEAAkE;IAClE,qEAAqE;IACrE,mEAAmE;IACnE,sEAAsE;IACtE,sEAAsE;IACtE,mEAAmE;IACnE,sEAAsE;IACtE,sEAAsE;IACtE,2EAA2E;AAC/E;;AAEA,uFAAuF;AACvF;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA,0FAA0F;AAC1F;IACI;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,cAAc;QACd,gBAAgB;QAChB,2BAA2B;IAC/B;AACJ;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".wrapper {\n    min-height: 400px;\n    display: flex;\n    flex-direction: column;\n}\n\n.table-title {\n    margin-bottom: 12px;\n    margin-left: 12px;\n}\n\n.soc-cell {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    flex-direction: column;\n}\n\n.soc-cell-timeline {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n}\n\n.soc-value {\n    margin-right: 5px;\n}\n\n.fixed-column-height {\n    height: 608px;\n}\n\n.card-height {\n    height: 210px;\n}\n\n.metric-text {\n    font-size: 15px;\n}\n\n.usage-history-chart {\n    width: 100%;\n}\n\n.history-segement {\n    width: 100%;\n    display: flex;\n    margin-right: 2px;\n}\n\n/* Project dropdown - dynamic width for long names */\n[data-test=\"Cat-projects-Dropdown\"] {\n    min-width: 190px;\n    max-width: 400px;\n    width: auto;\n}\n\n[data-test=\"Cat-projects-Dropdown\"]::part(trigger) {\n    white-space: nowrap;\n    width: auto;\n}\n\n[data-test=\"Cat-projects-Dropdown\"]::part(label) {\n    white-space: nowrap;\n    display: block;\n}\n\n/* Prevent text selection on panel headers */\n[data-test=\"map-title\"],\n[data-test=\"network-diagram-title\"],\ncat-heading {\n    user-select: none;\n}\n\n/*\n * Refreshed Live Dashboard chrome (eflowLiveDashboardRefresh flag).\n * These .live-dashboard-* classes are applied by ProjectDetails only on the Live tab, so\n * the legacy layout is untouched when the flag is off. Blocks components are shadow-DOM\n * web components, so their internals are reachable only through ::part().\n * The tag+class selector also outranks the [data-test=\"Cat-projects-Dropdown\"] rules\n * above, so these overrides win without needing !important.\n */\ncat-dropdown.live-dashboard-project-dropdown {\n    min-width: 0;\n    max-width: 100%;\n    width: auto;\n\n    --cat-panel-box-shadow: 0 2px var(--box-shadow-med, 12px) 0 var(--shadows-default, rgb(31 31 31 / 24%));\n\n    /* Figma 26-44764 option rows are a fixed 40px tall with 4/8/8/8 padding and a 4px\n       radius; --cat-list-item-link-* are custom properties, so they cross the cat-list /\n       cat-list-item shadow boundaries from this single ancestor rule. */\n    --cat-list-item-link-min-height: 2.5rem;\n    --cat-list-item-link-padding-block-start: 0.25rem;\n    --cat-list-item-link-padding-block-end: 0.5rem;\n    --cat-list-item-link-padding-inline-start: 0.5rem;\n    --cat-list-item-link-padding-inline-end: 0.5rem;\n    --cat-list-item-link-border-radius: 0.25rem;\n}\n\n/*\n * Figma 26-44764 \"options menu\" is a fixed 313px wide regardless of the trigger's (name-sized)\n * width. isDynamicWidth can't be used for this: it also forces the trigger's own input-wrap to\n * that same width, stretching the pill itself. Targeting the panel part directly instead leaves\n * the trigger's width untouched.\n */\ncat-dropdown.live-dashboard-project-dropdown::part(panel-component) {\n    width: 19.5625rem;\n    margin-top: 0.1875rem;\n}\n\n/*\n * Figma 26-44764 keeps the trigger's plain border with no blue \"active\"/focus outline,\n * even while the panel is open. The component's own shadow-DOM rules\n * (.cat-is-active .cat-c-dropdown__body, .cat-c-dropdown__select:focus .cat-c-dropdown__body)\n * are two classes deep, which outranks this single-class ::part() selector, so !important\n * is required to win the cascade across the shadow boundary.\n */\ncat-dropdown.live-dashboard-project-dropdown::part(body) {\n    border-width: 0 !important;\n    background-color: transparent !important;\n    padding: 0;\n    outline: none !important;\n}\n\n/* Figma 26-44764 has no focus/active outline from a mouse click, but keyboard focus still\n   needs a visible indicator — :not(:focus-visible) leaves that untouched. */\ncat-dropdown.live-dashboard-project-dropdown::part(body):focus-visible {\n    outline: 2px solid var(--cat-theme-color-focus-ring) !important;\n    outline-offset: 2px;\n}\n\ncat-dropdown.live-dashboard-project-dropdown::part(body):focus:not(:focus-visible) {\n    outline: none;\n}\n\n/*\n * The dropdown-panel's own body is what CatDropdown caps to a short fixed max-height\n * and makes scrollable (hasScroll is always true internally, via .cat-has-scroll, which\n * is two classes deep and outranks this single-class ::part() selector without !important).\n * That cap is what abruptly clipped the list before reaching the \"Add New Project\" footer,\n * and its default native scrollbar is what showed up/down arrow buttons. Handing scroll\n * ownership to .live-dashboard-project-list-scroll (see ProjectDetails.tsx) instead lets\n * this element grow to fit exactly: up to 6 rows plus the always-visible footer.\n */\ncat-dropdown.live-dashboard-project-dropdown::part(dropdown-panel__body) {\n    max-height: none !important;\n    overflow: visible !important;\n}\n\n/*\n * Refreshed project dropdown scrollbar. The project list owns scrolling;\n * browser-native up/down arrow buttons are hidden.\n */\n.live-dashboard-project-list-scroll::-webkit-scrollbar {\n    width: 6px;\n}\n\n.live-dashboard-project-list-scroll::-webkit-scrollbar-button,\n.live-dashboard-project-list-scroll::-webkit-scrollbar-button:single-button,\n.live-dashboard-project-list-scroll::-webkit-scrollbar-button:vertical:start:decrement,\n.live-dashboard-project-list-scroll::-webkit-scrollbar-button:vertical:end:increment {\n    display: none;\n    width: 0;\n    height: 0;\n    background: transparent;\n    appearance: none;\n}\n\n.live-dashboard-project-list-scroll::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.live-dashboard-project-list-scroll::-webkit-scrollbar-thumb {\n    min-height: 40px;\n    border-radius: 2px;\n    background: #ccc;\n    box-shadow:\n        0 0 2px 0 #fff,\n        0 0 2px 0 #fff;\n}\n\n.live-dashboard-project-list-scroll::-webkit-scrollbar-thumb:hover {\n    background: #777;\n}\n\ncat-dropdown.live-dashboard-project-dropdown::part(text) {\n    font-size: 1.5rem;\n    font-weight: 600;\n    line-height: 2rem;\n    font-family: \"Roboto Flex\", sans-serif;\n}\n\ncat-dropdown.live-dashboard-project-dropdown::part(text-container) {\n    padding-right: 0;\n    padding-left: 0;\n}\n\ncat-dropdown.live-dashboard-project-dropdown:hover .live-dashboard-project-dropdown-transfer-icon-container {\n    background: var(--bg-subtle-hover, #ccc);\n}\n\n.live-dashboard-project-edit-tooltip {\n    --cat-theme-box-shadow-md: 0 6px 16px rgb(0 0 0 / 15%);\n}\n\ncat-tooltip.live-dashboard-project-edit-tooltip::part(content) {\n    backdrop-filter: blur(10px);\n}\n\ncat-tooltip.live-dashboard-project-edit-tooltip::part(part-default) {\n    padding: 0.125rem 0.5rem;\n}\n\n.live-dashboard-project-edit-button-container:hover {\n    background: var(--bg-subtle-hover, #ccc);\n}\n\ncat-button.live-dashboard-project-edit-button::part(button),\ncat-button.live-dashboard-project-edit-button::part(button):hover,\ncat-button.live-dashboard-project-edit-button::part(button):active {\n    background-color: transparent;\n    border-color: transparent;\n}\n\n/* Figma 26-41627 puts a 4px gap between the transfer icon and the project name. */\ncat-dropdown.live-dashboard-project-dropdown::part(input-wrap) {\n    gap: 0.25rem;\n}\n\n/*\n * Figma 26-41627 has no chevron: the pill is transfer icon -> project name -> edit.\n * Hiding the button part alone proved unreliable, so the icon part is hidden too.\n */\ncat-dropdown.live-dashboard-project-dropdown::part(chevron-down-button),\ncat-dropdown.live-dashboard-project-dropdown::part(arrow-icon),\ncat-dropdown.live-dashboard-project-dropdown::part(icon-wrapper),\ncat-dropdown.live-dashboard-project-dropdown::part(separator) {\n    display: none;\n}\n\n/* Figma 26-44764 \"options menu\" list rows: project name is body/default (16px/24px). cat-list-item\n   is slotted content (not part of cat-dropdown's own shadow tree), so it's reached directly. */\ncat-dropdown.live-dashboard-project-dropdown cat-list-item::part(text) {\n    font-family: \"Roboto Flex\", sans-serif;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    color: #1f1f1f;\n}\n\n/* Figma 26-44764 has no checkmark on the selected row — just the status badge. */\ncat-dropdown.live-dashboard-project-dropdown cat-list-item::part(icon-after) {\n    display: none;\n}\n\n/* Figma 26-44764 rows are all white; grey is a hover-only state, not a persistent\n   \"current selection\" background. The component keys that persistent background off\n   the host's own internal aria-selected/current state (list-item.styles.ts), which lives\n   entirely inside its shadow DOM and outranks any ::part() override on specificity alone,\n   so !important is required here. :not(:hover) leaves the real hover feedback untouched. */\ncat-dropdown.live-dashboard-project-dropdown cat-list-item::part(link):not(:hover) {\n    background-color: var(--cat-theme-color-background-default, #fff) !important;\n}\n\n/* Badge label is CSS-generated (not a text node) so cat-dropdown's textContent-based trigger\n   label (see getSelectedItemLabel in dropdown.ts) never picks it up — see ProjectDetails.tsx. */\n.project-status-badge::after {\n    content: attr(data-label);\n}\n\n/*\n * Roboto Flex across the refreshed Asset Portfolio / Network Diagram / Map panels.\n * Blocks components read their font from these design tokens rather than an inherited\n * font-family, and custom properties are the only thing that crosses the shadow\n * boundary, so the tokens are redeclared alongside the plain font-family.\n */\n.live-dashboard-panel {\n    font-family: \"Roboto Flex\", sans-serif;\n\n    --cat-theme-typography-body-font-family: \"Roboto Flex\", sans-serif;\n    --cat-theme-typography-body-sm-font-family: \"Roboto Flex\", sans-serif;\n    --cat-theme-typography-label-font-family: \"Roboto Flex\", sans-serif;\n    --cat-theme-typography-label-lg-font-family: \"Roboto Flex\", sans-serif;\n    --cat-theme-typography-label-sm-font-family: \"Roboto Flex\", sans-serif;\n    --cat-theme-typography-title-font-family: \"Roboto Flex\", sans-serif;\n    --cat-theme-typography-title-sm-font-family: \"Roboto Flex\", sans-serif;\n    --cat-theme-typography-footnote-font-family: \"Roboto Flex\", sans-serif;\n    --cat-theme-typography-footnote-bold-font-family: \"Roboto Flex\", sans-serif;\n}\n\n/* Google Maps sets its own font on .gm-style, so inheritance alone never reaches it. */\n.live-dashboard-panel .gm-style,\n.live-dashboard-panel .gm-style .gm-style-iw {\n    font-family: \"Roboto Flex\", sans-serif;\n}\n\ncat-tabs.live-dashboard-tabs::part(header) {\n    justify-content: center;\n    margin-bottom: 1.5rem;\n}\n\ncat-tabs.live-dashboard-tabs::part(list) {\n    max-width: 100%;\n}\n\n/* Centre the tab strip against the page header once there is room for it (Tailwind xl). */\n@media (width >= 1280px) {\n    cat-tabs.live-dashboard-tabs::part(header) {\n        position: absolute;\n        top: 46px;\n        left: 50%;\n        max-width: 42%;\n        margin-bottom: 0;\n        transform: translateX(-50%);\n    }\n}\n\ncat-tab.live-dashboard-tabs-item::part(button) {\n    width: 127px;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n}\n\ncat-tab.live-dashboard-tabs-item::part(wrap) {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
